import { withCompController } from '@wix/editor-elements-integrations';
import { getSocialUrl } from '@wix/editor-elements-common-utils';
import {
  WFacebookCommentMapperProps,
  WFacebookCommentControllerProps,
  WFacebookCommentProps,
  WFacebookCommentStateRefs,
} from '../WFacebookComment.types';
import { mapConsentPolicyStateRefValues } from '../../ConsentPolicyWrapper/viewer/utils';

const compController = withCompController<
  WFacebookCommentMapperProps,
  WFacebookCommentControllerProps,
  WFacebookCommentProps,
  WFacebookCommentStateRefs
>(({ stateValues, mapperProps }) => {
  const { urlFormat, externalBaseUrl, isHttpsEnabled, ...restProps } =
    mapperProps;

  const { pageId, relativeUrl, currentUrlWithQueryParams } = stateValues;

  const socialUrl = getSocialUrl({
    urlFormat,
    isMasterPage: false,
    pageId,
    relativeUrl,
    externalBaseUrl,
    isHttpsEnabled,
    currentUrl: currentUrlWithQueryParams,
  });

  return {
    ...restProps,
    socialUrl,
    ...mapConsentPolicyStateRefValues(stateValues),
  };
});

export default compController;
